import { create } from 'zustand';

interface TranscriptPanelState {
  isOpen: boolean;
  conversationId: string | null;
  highlightMessageId: string | null;
  /**
   * Optional question context for fallback scroll targeting. When the
   * caller doesn't have an exact `highlightMessageId` (e.g., a citation
   * for a respondent not in the curated voice_quotes set), the panel
   * uses this question_id to scroll to the respondent's answer for
   * that question instead of opening at the top.
   */
  fallbackQuestionId: string | null;
  open: (
    conversationId: string,
    highlightMessageId?: string,
    fallbackQuestionId?: string,
  ) => void;
  close: () => void;
}

const useTranscriptPanelStore = create<TranscriptPanelState>((set) => ({
  isOpen: false,
  conversationId: null,
  highlightMessageId: null,
  fallbackQuestionId: null,
  open: (
    conversationId: string,
    highlightMessageId?: string,
    fallbackQuestionId?: string,
  ) =>
    set({
      isOpen: true,
      conversationId,
      highlightMessageId: highlightMessageId ?? null,
      fallbackQuestionId: fallbackQuestionId ?? null,
    }),
  close: () =>
    set({
      isOpen: false,
      conversationId: null,
      highlightMessageId: null,
      fallbackQuestionId: null,
    }),
}));

export default useTranscriptPanelStore;
